export default __webpack_public_path__ + "static/media/emoji_courses.cb34be6d.svg";